import { EnergyType } from "../types/energyType"
import { type SelectedEnergyTypes } from "../types/selectedEnergyTypes"

export function isMonoEnergy(selectedEnergyTypes: SelectedEnergyTypes) {
    return selectedEnergyTypes?.length === 1
}

export function isElectricityOnly(selectedEnergyTypes: SelectedEnergyTypes) {
    return isMonoEnergy(selectedEnergyTypes) && selectedEnergyTypes[0] === EnergyType.Electricity
}

export function isGasOnly(selectedEnergyTypes: SelectedEnergyTypes) {
    return isMonoEnergy(selectedEnergyTypes) && selectedEnergyTypes[0] === EnergyType.Gas
}
